import { Box, Skeleton } from '@mui/material'
import { FC } from 'react'
import { border } from '../../layout/theme/border'

export const SkeletonCard: FC = () => (
  <Box sx={{ p: 3, borderRadius: border.card.radius, background: '#fff', border: '1px solid rgba(0,0,0,0.06)' }}>
    <Skeleton variant="text" width={80} height={44} sx={{ mb: 0.5 }} />
    <Skeleton variant="text" width={120} height={18} />
  </Box>
)
